import React from 'react';
import { Chip, Avatar } from '@mui/material';
import PropTypes from 'prop-types';
import './DetailsEdited.css';
import ColorConstants from '../../defaults/ColorConstants';

export default function DetailsEdited({chipClicked, unsavedFields}) {
  const unsavedFieldsMessage = "Unsaved Fields";
  return(
    <Chip
      className="required-field-status-chip"
      onClick={chipClicked}
      style={{backgroundColor: `${ColorConstants.AvatarBackgroundColor}`}}
      avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.UnsavedAvatarColor, color: ColorConstants.WhiteAlien }}>{unsavedFields}</Avatar>}
      label={<span style={{fontSize: "12px", lineHeight: "21px"}}>{unsavedFieldsMessage}</span>}
    />
  )
}